// Opinion datasets (#1179, specs/opinion-datasets.md) — the `opinionDatasets` namespace:
// Aineistot → Tietopohjat (opinion datasets among every kind, #1369) and the opinion rows of Valmistelu → Tietopohja.

export const opinionDatasetsFi = {
  lead: "Kyselyt ja keskustelut, joissa ihmiset ottivat kantaa väittämiin ja jakautuivat mielipideryhmiin (esim. Voxit). Ne pidetään erillään tutkimusaineistoista: tekoälyn tavallinen analyysi ei koskaan näe niitä, ja vain mielipideaineistoa käyttävä moduuli arvioi niiden avulla, miten ryhmät suhtautuisivat ehdotuksiin.",
  counts: "{{opinions}} väittämää · {{groups}} ryhmää",
  profilesMissing: "Ryhmäprofiilit puuttuvat",
  profilesReady: "Profiilit valmiina",
  import: {
    title: "Tuo mielipideaineisto",
    open: "Tuo uusi",
    format: "Lähde",
    voxitPdf: "Voxit-raportti, joka on jo indeksoitu tietopohjaan",
    polisCsv: "Pol.is- tai Voxit-vienti (CSV)",
    datasetId: "Tunniste",
    datasetIdHelp: "Pienet kirjaimet, numerot ja väliviivat, esim. voxit-tyoperainen-maahanmuutto-2026. Sama tunniste päivittää aineiston.",
    name: "Nimi",
    documentSearch: "Hae dokumenttia nimellä",
    documentNone: "Ei osumia.",
    documentChunks: "{{chunks}} palaa",
    commentGroups: "comment-groups.csv",
    comments: "comments.csv (valinnainen: rajaa julkaistuihin väittämiin)",
    submit: "Tuo",
    importing: "Tuodaan ja lasketaan upotuksia…",
    done: "Tuotu: {{opinions}} väittämää, {{background}} taustaväittämää, {{groups}} ryhmää.",
    cancel: "Peruuta",
  },
  view: {
    back: "Kaikki mielipideaineistot",
    settings: "Aineisto",
    name: "Nimi",
    populationNote: "Ketä luvut kuvaavat",
    populationNoteHelp: "Näytetään jokaisen arvion vieressä.",
    save: "Tallenna",
    saved: "Tallennettu.",
    groups: "Mielipideryhmät",
    groupsLead: "Profiili on se, mistä tekoäly päättelee ryhmän reaktion ehdotukseen, jota mikään väittämä ei käsittele. Luo luonnos tekoälyllä, lue se ja korjaa: kuvauksen pitää olla reilu, niin että ryhmän jäsen tunnistaisi sen.",
    label: "Nimi",
    profile: "Profiili",
    profileEmpty: "Ei profiilia.",
    sourceSummary: "Lähteen oma tiivistys",
    buildProfiles: "Luo profiilit tekoälyllä",
    rebuildProfiles: "Luo profiilit uudelleen",
    rebuildConfirm: "Tekoäly kirjoittaa kaikkien ryhmien profiilit uudelleen, ja käsin tehdyt muutokset korvautuvat. Jatketaanko?",
    building: "Luodaan profiilia: {{stage}}",
    buildFailed: "Profiilien luonti epäonnistui: {{message}}",
    statements: "Väittämät",
    statementsCount: "{{count}} väittämää",
    colId: "#",
    colStatement: "Väittämä",
    colTheme: "Teema",
    colClass: "Luokka",
    background: "Taustaväittämä",
    seed: "Järjestäjän",
  },
  classification: {
    unifying: "Yhdistävä",
    divisive: "Ryhmiä jakava",
    partly_divisive: "Osittain jakava",
    split_within: "Jakautunut ryhmien sisällä",
  },
  instance: {
    notReady: "Ryhmäprofiilit puuttuvat: luo ne Aineistot → Tietopohjat -sivulla (laji Mielipiteet).",
  },
};

export const opinionDatasetsEn = {
  lead: "Surveys and discussions where people took positions on statements and fell into opinion groups (e.g. Voxit). They are kept apart from research datasets: the AI's normal analysis never sees them, and only a module that uses opinion data estimates from them how the groups would react to proposals.",
  counts: "{{opinions}} statements · {{groups}} groups",
  profilesMissing: "Group profiles missing",
  profilesReady: "Profiles ready",
  import: {
    title: "Import an opinion dataset",
    open: "Import new",
    format: "Source",
    voxitPdf: "A Voxit report already indexed into the knowledge base",
    polisCsv: "A Pol.is or Voxit export (CSV)",
    datasetId: "Identifier",
    datasetIdHelp: "Lowercase letters, digits and hyphens, e.g. voxit-work-immigration-2026. The same identifier updates the dataset.",
    name: "Name",
    documentSearch: "Search a document by name",
    documentNone: "No matches.",
    documentChunks: "{{chunks}} chunks",
    commentGroups: "comment-groups.csv",
    comments: "comments.csv (optional: limits to published statements)",
    submit: "Import",
    importing: "Importing and computing embeddings…",
    done: "Imported: {{opinions}} statements, {{background}} background statements, {{groups}} groups.",
    cancel: "Cancel",
  },
  view: {
    back: "All opinion datasets",
    settings: "Dataset",
    name: "Name",
    populationNote: "Who the numbers describe",
    populationNoteHelp: "Shown next to every estimate.",
    save: "Save",
    saved: "Saved.",
    groups: "Opinion groups",
    groupsLead: "The profile is what the AI reasons from when no statement is about a proposal. Draft it with AI, read it and correct it: it must be fair enough that a member of the group would recognise it.",
    label: "Name",
    profile: "Profile",
    profileEmpty: "No profile.",
    sourceSummary: "The source's own summary",
    buildProfiles: "Draft profiles with AI",
    rebuildProfiles: "Redraft profiles",
    rebuildConfirm: "The AI rewrites every group's profile, replacing any manual edits. Continue?",
    building: "Drafting profile: {{stage}}",
    buildFailed: "Drafting the profiles failed: {{message}}",
    statements: "Statements",
    statementsCount: "{{count}} statements",
    colId: "#",
    colStatement: "Statement",
    colTheme: "Theme",
    colClass: "Class",
    background: "Background statement",
    seed: "Organiser's",
  },
  classification: {
    unifying: "Unifying",
    divisive: "Divisive",
    partly_divisive: "Partly divisive",
    split_within: "Split within groups",
  },
  instance: {
    notReady: "Group profiles are missing: draft them in Aineistot → Tietopohjat (kind Opinion).",
  },
};

export const opinionDatasetsSv = {
  lead: "Enkäter och diskussioner där människor tog ställning till påståenden och delades in i opinionsgrupper (t.ex. Voxit). De hålls åtskilda från forskningsdata: AI:ns vanliga analys ser dem aldrig, och bara en modul som använder opinionsdata uppskattar med dem hur grupperna skulle reagera på förslag.",
  counts: "{{opinions}} påståenden · {{groups}} grupper",
  profilesMissing: "Gruppprofiler saknas",
  profilesReady: "Profilerna klara",
  import: {
    title: "Importera opinionsdata",
    open: "Importera ny",
    format: "Källa",
    voxitPdf: "En Voxit-rapport som redan indexerats i kunskapsbasen",
    polisCsv: "En Pol.is- eller Voxit-export (CSV)",
    datasetId: "Identifierare",
    datasetIdHelp: "Små bokstäver, siffror och bindestreck, t.ex. voxit-arbetskraftsinvandring-2026. Samma identifierare uppdaterar datamängden.",
    name: "Namn",
    documentSearch: "Sök ett dokument med namn",
    documentNone: "Inga träffar.",
    documentChunks: "{{chunks}} delar",
    commentGroups: "comment-groups.csv",
    comments: "comments.csv (valfri: begränsar till publicerade påståenden)",
    submit: "Importera",
    importing: "Importerar och beräknar inbäddningar…",
    done: "Importerat: {{opinions}} påståenden, {{background}} bakgrundspåståenden, {{groups}} grupper.",
    cancel: "Avbryt",
  },
  view: {
    back: "Alla opinionsdata",
    settings: "Datamängd",
    name: "Namn",
    populationNote: "Vem siffrorna beskriver",
    populationNoteHelp: "Visas bredvid varje uppskattning.",
    save: "Spara",
    saved: "Sparat.",
    groups: "Opinionsgrupper",
    groupsLead: "Profilen är det AI:n resonerar utifrån när inget påstående gäller ett förslag. Låt AI:n skissa den, läs och rätta den: den ska vara så rättvis att en medlem i gruppen skulle känna igen den.",
    label: "Namn",
    profile: "Profil",
    profileEmpty: "Ingen profil.",
    sourceSummary: "Källans egen sammanfattning",
    buildProfiles: "Skissa profiler med AI",
    rebuildProfiles: "Skissa profilerna på nytt",
    rebuildConfirm: "AI:n skriver om alla gruppers profiler och ersätter manuella ändringar. Fortsätta?",
    building: "Skissar profil: {{stage}}",
    buildFailed: "Profilerna kunde inte skissas: {{message}}",
    statements: "Påståenden",
    statementsCount: "{{count}} påståenden",
    colId: "#",
    colStatement: "Påstående",
    colTheme: "Tema",
    colClass: "Klass",
    background: "Bakgrundspåstående",
    seed: "Arrangörens",
  },
  classification: {
    unifying: "Förenande",
    divisive: "Delande",
    partly_divisive: "Delvis delande",
    split_within: "Delat inom grupperna",
  },
  instance: {
    notReady: "Gruppprofiler saknas: skissa dem under Aineistot → Tietopohjat (typ Opinioner).",
  },
};
